import {postRequest} from "redux-request-middleware";
import {IDocUploadBody, IDocDetails, IDocument} from "StateInterface";
import {DocTypes} from "userform/utils";
import {setCurrentDocTypeForEventTracking} from "analytics/branch";
import {gatewayUrl, hagenUrl} from "config";

export enum Actions {
    REQUEST_DOCUMENTS = "REQUEST_DOCUMENTS",
    REQUEST_SAVE_DOCUMENT = "REQUEST_SAVE_DOCUMENT",
    SET_DOCUMENT_UPLOAD_STATUS = "SET_DOCUMENT_UPLOAD_STATUS",
    SET_PREFILL_DOCS = "SET_PREFILL_DOCS",
    CLEAR_DOC_UPLOAD_ERROR = "CLEAR_DOC_UPLOAD_ERROR",
}
export function setDocumentUploadStatus() {
    return {
        type: Actions.SET_DOCUMENT_UPLOAD_STATUS,
    };
}
export function uploadDocument(userId: number, docType: DocTypes, docBody: IDocUploadBody) {
    setCurrentDocTypeForEventTracking(docType);
    return (dispatch) => {
      dispatch(
        postRequest(
          Actions.REQUEST_SAVE_DOCUMENT,
          `document/${userId}/${docType}`,
          docBody,
          false,
          {docType},
        ),
      );
    };
}

export function uploadKYCDocument(docType: DocTypes, docBody: IDocDetails) {
  setCurrentDocTypeForEventTracking(docType);
  return (dispatch) => {
    dispatch(
      postRequest(
        Actions.REQUEST_SAVE_DOCUMENT,
        'paandu/docs',
        docBody,
        false,
        {docType, ...(docBody.docSubType) ? {docSubType: docBody.docSubType} : {}},
        null,
        gatewayUrl,
      ),
    );
  };
}

export const clearDocUploadError = () => {
  return {type: Actions.CLEAR_DOC_UPLOAD_ERROR};
};

export function setPrefillDocs(docNames: IDocument[]) {
    return {type: Actions.SET_PREFILL_DOCS, body: docNames};
}

export const uploadNach = (contentType: string, docType: DocTypes, userId: number, docContentB64: string, opportunityId: string) => {
  setCurrentDocTypeForEventTracking(docType);
    return (dispatch) => {
      dispatch(
        postRequest(
          Actions.REQUEST_SAVE_DOCUMENT,
          "upload-signed-paper-nach",
          {
            contentType,
            docContent: docContentB64,
            opportunityId,
            userId,
          },
          false,
          {docType},
          null,
          hagenUrl,
        ),
      );
    };
}
